<template>
  <div>
    <!-- 学生考勤---我的考勤 -->
    <div class="stat-select">
      <SelectTimeDate ref="SelectTimeDate" @timeDate="GetStudentAttStatisticSummary_date"></SelectTimeDate>
      <div class="select-more" @click="screen">
        <span>筛选</span>
        <img :src="require('@/assets/attendance/more@2x.png')" />
      </div>
      <div class="stat-show">
        <span v-for="(item, index) in showName" :key="index">{{item.label}}</span>
      </div>
    </div>
    <Attendance v-bind:StudentNum="StudentNum"></Attendance>
    <Proportion v-bind:Summary="Summary"></Proportion>
    <div class="end-time">数据截止到：{{xy.moment(EndTime).format('YYYY-MM-DD HH:mm')}}</div>
    <SelectLayerTeacher
      ref="SelectLayer"
      :isShowSelectLayer="isShowSelectLayer"
      :layerList="layerList"
      @LayerClose="layerClose"
      @SelectLayer="selectLayer"
    ></SelectLayerTeacher>
  </div>
</template>
<script>
import SelectTimeDate from "@/pages/attendance/components/SelectTimeDate";
import Attendance from "@/pages/attendance/components/Attendance";
import Proportion from "@/pages/attendance/components/Proportion";
import SelectLayerTeacher from "@/pages/attendance/components/SelectLayerTeacher";

export default {
  name: "AttendanceTeach",
  components: {
    SelectTimeDate,
    Attendance,
    Proportion,
    SelectLayerTeacher
  },
  data() {
    return {
      timeDate: [],
      StudentNum: "",
      Summary: [],
      EndTime: new Date(),
      isShowSelectLayer: false,
      layerList: [],
      num: 0,

      SchoolDistrictID: 0,
      GradeYearID: 0,
      DisciplineID: 0,
      ClassID: "",
      ApplicationID: 0,
      ApplicationSubMenuID: 0,
      showName: []
    };
  },
  created() {
    console.log(this.$store.state.common)
    this.ApplicationID = this.$store.state.common.menuIDs[1]
    this.ApplicationSubMenuID = this.$store.state.common.menuIDs[2]
    // this.ApplicationSubMenuID = 80
    this.GetUserRangeDisciplineAndClassPermissionMobile();
  },
  watch: {},
  mounted() {},
  methods: {
    // 获取层级
    async GetUserRangeDisciplineAndClassPermissionMobile() {
      this.xy.loading();
      let params = {
        applicationID: this.ApplicationID,
        ApplicationSubMenuID: this.ApplicationSubMenuID,
        IsContainsLogin: true
      };
      let res = await this.xyapi.get(
        this.xyMApi +
          "/att/xy/comm/GetUserRangeDisciplineAndClassPermission",
        params
      );
      if (res.success) {
        let layerList = [];
        layerList = res.data;
        if (layerList.length > 0) {
          // let gradelArr = {
          //   IsCurrent: false,
          //   children: [
          //     {
          //       IsCurrent: false,
          //       children: [
          //         {
          //           IsCurrent: false,
          //           children: [],
          //           label: "所有班级",
          //           value: 0
          //         }
          //       ],
          //       label: "所有学科",
          //       value: 0
          //     }
          //   ],
          //   label: "所有年级",
          //   value: 0
          // };
          // let subjectArr = {
          //   IsCurrent: false,
          //   children: [
          //     {
          //       IsCurrent: false,
          //       children: [],
          //       label: "所有班级",
          //       value: 0
          //     }
          //   ],
          //   label: "所有学科",
          //   value: 0
          // };
          // let classArr = {
          //   IsCurrent: false,
          //   children: [],
          //   label: "所有班级",
          //   value: 0
          // };
          // for (var i = 0; i < layerList.length; i++) {
          //   for (var j = 0; j < layerList[i].children.length; j++) {
          //     for(var c= 0; c < layerList[i].children[j].children.length; c++) {
          //       layerList[i].children[j].children[c].children.splice(0, 0, classArr);
          //     }
          //     layerList[i].children[j].children.splice(0, 0, subjectArr);
          //   }
          //   layerList[i].children.splice(0, 0, gradelArr);
          // }
          this.layerList = layerList;
          // 默认选中第一个校区
          this.showName = [];
          console.log(this.layerList)
          for (var a = 0; a < this.layerList.length; a++) {
            if (a === 0) {
              this.showName.push(this.layerList[0])
              // for (var s = 0; s < this.layerList[a].children.length; s++) {
              //   if (s === 0) {
              //     this.showName.push(this.layerList[0].children[s])
              //     for (var d = 0; d < this.layerList[0].children[s].children.length; d++) {
              //       if (d === 0) {
              //         this.showName.push(this.layerList[0].children[s].children[d])
              //         for (var g = 0; g < this.layerList[0].children[s].children[d].children.length; g++) {
              //           if (g ===0) {
              //             this.showName.push(this.layerList[0].children[s].children[d].children[g])
              //           }
              //         }
              //       }
              //     }
              //   }
              // }
            }
          }
          for (var f = 0; f < this.showName.length; f++ ) {
            this.showName[f].IsCurrent = true
          }
          console.log(11,this.showName)
          
          this.SchoolDistrictID = this.layerList[0].value;
          // this.GradeYearID = this.layerList[0].children[0]?this.layerList[0].children[0].value:0;
          // this.DisciplineID = this.layerList[0].children[0].children[0]?this.layerList[0].children[0].children[0].value:0;
          // this.ClassID = this.layerList[0].children[0].children[0].children[0]?this.layerList[0].children[0].children[0].children[0].value:0;
          
          this.GetStudentAttStatisticSummary(this.timeDate);
        } else {
          this.$toast.fail("您无有效的教学班");
        }
      }
    },

    // 获取数据
    async GetStudentAttStatisticSummary(item) {
      this.num++;
      this.xy.loading();
      this.timeDate = item;
      let params = {
        SchoolDistrictID: this.SchoolDistrictID,//学校
        GradeYearID: this.GradeYearID,//年级
        DisciplineID: this.DisciplineID,//学科
        ClassID: this.ClassID,//班级
        ApplicationID: this.ApplicationID,
        ApplicationSubMenuID: this.ApplicationSubMenuID,
        StartTime: this.timeDate[0],
        EndTime: this.timeDate[1],
        AMorPM: "",
        AMorPMOrder: "-1"
      };
      let res = await this.xyapi.get(
        this.$store.state.apiPath +
          "/api/ClassAttStatisticsMb/GetStudentAttStatisticSummary",
        params
      );
      this.xy.unloading();
      if (res.success) {
        this.StudentNum = [];
        this.StudentNum = res.data;
        if(res.data.Summary === null ){
          this.Summary = [];
        }else{
          this.Summary = res.data.Summary;
        }
        this.EndTime = res.data.EndTime;
      }
    },

    //空方法 赋值数据
    GetStudentAttStatisticSummary_date(item) {
      this.timeDate = item;
      if (this.num !== 0) {
        this.GetStudentAttStatisticSummary(this.timeDate);
      }
    },

    //筛选
    screen() {
      console.log(this.showName)
      if (this.layerList.length > 0) {
        this.isShowSelectLayer = true;
      } else {
        this.$toast.fail("您无有效的教学班");
      }
    },

    // 点击关闭
    layerClose(item) {
      this.isShowSelectLayer = item;
    },
    // 确定
    selectLayer(item) {
      console.log(item);
      this.showName = item
      this.SchoolDistrictID = item[0].value;
      this.GradeYearID = item[1]?item[1].value:0;
      this.DisciplineID = item[2]?item[2].value:0;
      this.ClassID  = item[3]?item[3].value:'';
      this.GetStudentAttStatisticSummary(this.timeDate);
    }
  }
};
</script>
<style lang="less" scoped>
.stat-select {
  background: #fff;
  overflow: hidden;
  margin-bottom: 20px;
}
.select-more {
  display: inline-block;
  vertical-align: middle;
  position: absolute;
  right: 20px;
  top: 120px;
  span {
    margin-right: 10px;
    font-size: 28px;
    font-family: PingFang-SC-Regular, PingFang-SC;
    font-weight: 400;
    color: rgba(96, 96, 96, 1);
  }
  img {
    width: 24px;
  }
}
.end-time {
  position: fixed;
  bottom: 0;
  text-align: center;
  width: 100%;
  color: #888;
  padding: 7px 0;
  background-color: #f9f9f9 !important;
}
.stat-show {
  width: 100%;
  span {
    display: inline-block;
    color: #2980fe;
    background: #d7e7ff;
    border-radius: 2px;
    margin: 8px 10px;
    padding: 3px 10px;
  }
}
</style>